import styled, { css } from "styled-components";

// Change the width of the modal
export const modalStyles = css`
  #modal-container {
    width: 40vw !important;
  }
`;

export const EditCampaignDataModalWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr auto;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  background-color: var(--primary-dark-600);
  color: var(--primary-white);
  padding: 23px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.h1`
  color: var(--primary-dark-300);
  font-size: var(--fs-sm);
  font-weight: 400;
  line-height: var(--lh-sm);
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-dark-500);
  color: var(--primary-white);
  padding: 7px;
  border: none;
  cursor: pointer;
  outline: none;
  border-radius: 50%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
  background-color: var(--primary-dark-50);
  color: var(--primary-dark-300);
  padding: 23px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
`;

export const ContentTitle = styled.span`
  color: var(--primary-dark-300);
  font-size: var(--fs-base);
  font-weight: 400;
  line-height: var(--lh-base);
`;

export const FilterButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
`;

export const FilterButton = styled.button`
  padding: 8px 16px;
  border: 1px solid var(--primary-blue);
  background: none;
  color: var(--primary-blue);
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background-color: var(--primary-blue-50);
  }

  &.active {
    background-color: var(--primary-blue);
    color: white;
    font-weight: 600;
  }
`;

export const UploadButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  width: 100%;
`;

export const UploadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  border: 1px solid var(--primary-blue);
  background: transparent;
  color: var(--primary-blue);
  font-size: var(--fs-base);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 4px;

  &:hover {
    background-color: var(--primary-blue-50);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;
